import React, { ChangeEvent } from 'react';
import { ProductAttributeType } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    name: string;
    value: ProductAttributeType;
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: ProductAttributeType, name: string) => void;
}

interface State {
    value: ProductAttributeType;
}

class ProductAttributeTypeSelect extends React.Component<Props & InjectedIntlProps, State> {

    public state = {
        value: ProductAttributeType.SIMPLE,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <>
                <select
                    name={this.props.name}
                    value={this.state.value}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { this.props.onChangeHandler((e.currentTarget.value as ProductAttributeType), this.props.name); }}
                    className="form-control"
                >
                    {Object.keys(ProductAttributeType).map((type: string) => (
                        <option key={type} value={ProductAttributeType[type]}>{this.props.intl.formatMessage({id: `component.ProductAttributeTypeSelect.option.${ProductAttributeType[type]}`})}</option>
                    ))}
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductAttributeTypeSelect);



// WEBPACK FOOTER //
// ./src/components/Form/ProductAttributeTypeSelect.tsx